import React from 'react';
import { companyInfo, serviceAreas } from '../data/mock';

const CityServiceSchema = ({ city, serviceTitle, serviceId }) => {
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": `${serviceTitle} in ${city.name}, TX`,
    "description": `Professional ${serviceTitle.toLowerCase()} in ${city.name}, Texas. 55+ years serving ${city.name} homeowners.`,
    "provider": {
      "@type": "HomeAndConstructionBusiness",
      "name": companyInfo.name,
      "telephone": companyInfo.phone,
      "url": "https://graycontractingdfw.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": companyInfo.addressStreet,
        "addressLocality": companyInfo.addressCity,
        "addressRegion": "TX",
        "postalCode": companyInfo.addressZip
      },
      "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "reviewCount": "127" }
    },
    "areaServed": { "@type": "City", "name": city.name, "containedInPlace": { "@type": "State", "name": "Texas" } },
    "serviceType": serviceTitle
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": city.faqs.map(faq => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": { "@type": "Answer", "text": faq.a }
    }))
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://graycontractingdfw.com" },
      { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://graycontractingdfw.com/services" },
      { "@type": "ListItem", "position": 3, "name": serviceTitle, "item": `https://graycontractingdfw.com/services/${serviceId}` },
      { "@type": "ListItem", "position": 4, "name": `${city.name}, TX`, "item": `https://graycontractingdfw.com/services/${serviceId}/${city.slug}` }
    ]
  };

  const localSchema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": `${companyInfo.name} - ${city.name} ${serviceTitle}`,
    "url": `https://graycontractingdfw.com/services/${serviceId}/${city.slug}`,
    "telephone": companyInfo.phone,
    "address": { "@type": "PostalAddress", "addressLocality": city.name, "addressRegion": "TX" },
    "areaServed": serviceAreas.map(a => ({ "@type": "City", "name": a })),
    "priceRange": "$$"
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(localSchema) }} />
    </>
  );
};

export default CityServiceSchema;
